/**
 * ISO day of week: Monday = 1 … Sunday = 7 (matches Carbon::dayOfWeekIso en backend).
 * Espejo de backend App\Enums\DayOfWeekEnum.
 */
export enum DayOfWeekEnum {
  Monday = 'monday',
  Tuesday = 'tuesday',
  Wednesday = 'wednesday',
  Thursday = 'thursday',
  Friday = 'friday',
  Saturday = 'saturday',
  Sunday = 'sunday',
}

/** ISO day of week (1 = Monday, 7 = Sunday). Usar con dayjs: date.isoWeekday() o date.day(dayOfWeekIso). */
export function dayOfWeekIso(day: DayOfWeekEnum): number {
  const map: Record<DayOfWeekEnum, number> = {
    [DayOfWeekEnum.Monday]: 1,
    [DayOfWeekEnum.Tuesday]: 2,
    [DayOfWeekEnum.Wednesday]: 3,
    [DayOfWeekEnum.Thursday]: 4,
    [DayOfWeekEnum.Friday]: 5,
    [DayOfWeekEnum.Saturday]: 6,
    [DayOfWeekEnum.Sunday]: 7,
  };
  return map[day];
}

export function fromDayOfWeekIso(isoDay: number): DayOfWeekEnum {
  const map: Record<number, DayOfWeekEnum> = {
    1: DayOfWeekEnum.Monday,
    2: DayOfWeekEnum.Tuesday,
    3: DayOfWeekEnum.Wednesday,
    4: DayOfWeekEnum.Thursday,
    5: DayOfWeekEnum.Friday,
    6: DayOfWeekEnum.Saturday,
    7: DayOfWeekEnum.Sunday,
  };
  const value = map[isoDay];
  if (value == null) {
    throw new Error(`Invalid ISO day of week: ${isoDay}`);
  }
  return value;
}

/** Valores del enum como array (para validaciones, opciones, etc.). */
export const DayOfWeekEnumValues: DayOfWeekEnum[] = Object.values(DayOfWeekEnum);

/** Días laborables (lunes a viernes). Usado cuando se exige al menos un periodo por día. */
export const workingDays: readonly DayOfWeekEnum[] = [
  DayOfWeekEnum.Monday,
  DayOfWeekEnum.Tuesday,
  DayOfWeekEnum.Wednesday,
  DayOfWeekEnum.Thursday,
  DayOfWeekEnum.Friday,
] as const;

export function isWorkingDay(day: DayOfWeekEnum): boolean {
  return (workingDays as readonly DayOfWeekEnum[]).includes(day);
}

/** Etiquetas de presentación por día (label completo y shortLabel). */
export const DayOfWeekLabels: Record<DayOfWeekEnum, { label: string; shortLabel: string }> = {
  [DayOfWeekEnum.Monday]: { label: 'Lunes', shortLabel: 'Lun.' },
  [DayOfWeekEnum.Tuesday]: { label: 'Martes', shortLabel: 'Mar.' },
  [DayOfWeekEnum.Wednesday]: { label: 'Miércoles', shortLabel: 'Mié.' },
  [DayOfWeekEnum.Thursday]: { label: 'Jueves', shortLabel: 'Jue.' },
  [DayOfWeekEnum.Friday]: { label: 'Viernes', shortLabel: 'Vie.' },
  [DayOfWeekEnum.Saturday]: { label: 'Sábado', shortLabel: 'Sáb.' },
  [DayOfWeekEnum.Sunday]: { label: 'Domingo', shortLabel: 'Dom.' },
};

/** Array de días con key + label + shortLabel para listados y formularios. */
export const DayOfWeekWithLabels: { key: DayOfWeekEnum; label: string; shortLabel: string }[] = DayOfWeekEnumValues.map(key => ({
  key,
  ...DayOfWeekLabels[key],
}));
